import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },

  border: {
    marginRight: '8px',
    borderRadius: '0px 8px 8px 0px',
    width: '4px',
    height: '19px',
    background: '#B64FCD',
    transform: 'matrix(1, 0, 0, -1, 0, 0)'
  },

  title: {
    marginRight: '8px',
    fontSize: theme.size.sm,
    color: '#B64FCD'
  },

  count: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100rem',
    height: '24px',
    padding: '0 5px',
    background: '#B64FCD',
    fontSize: theme.size.sm,
    color: 'white'
  },

  articles: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '-24px',
    maxHeight: 'calc(100svh - 175px)',
    paddingTop: '15px',
    overflow: 'hidden auto',

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.nearWhite
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 0
    }
  },

  newItem: {
    marginLeft: '33px',
    fontSize: theme.size.sm,
    color: '#B64FCD',
    cursor: 'pointer'
  }
}))

export default useStyles
